import { useQuery } from "@tanstack/react-query";
import { queryService } from "@/api/services/query-service";
import {
  TokenUsageHistoryModel,
  TokenUsageHistoryParams,
} from "@/api/models/api-types";

export const useTokenUsageHistoryByModel = (
  params: TokenUsageHistoryParams = {}
) => {
  return useQuery({
    queryKey: ["token-usage-history-by-model", params],
    queryFn: async () => {
      const response = await queryService.getTokenUsageHistoryByModel(params);
      return response.data;
    },
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    staleTime: 0, // her çağrıda taze kabul et
    gcTime: 5 * 60 * 1000, // cache temizleme süresi
  });
};

export const useUsage = (params: TokenUsageHistoryParams = {}) => {
  const {
    data: usageHistoryData,
    isLoading: isUsageHistoryLoading,
    error: usageHistoryError,
    refetch: refetchUsageHistory,
  } = useTokenUsageHistoryByModel(params);

  // Processed data
  const usageHistory: TokenUsageHistoryModel[] = usageHistoryData?.result || [];
  const totalPages = usageHistoryData?.meta?.totalPage || 1;
  const currentPage = usageHistoryData?.meta?.page || 1;
  const totalRecords = usageHistoryData?.meta?.total || 0;

  return {
    // Data
    usageHistory,
    totalPages,
    currentPage,
    totalRecords,

    // States
    isUsageHistoryLoading,
    usageHistoryError,

    // Actions
    refetchUsageHistory,
  };
};
